import { render, staticRenderFns } from "./detialBox.vue?vue&type=template&id=0ec7e6c8&scoped=true"
import script from "./detialBox.vue?vue&type=script&lang=js"
export * from "./detialBox.vue?vue&type=script&lang=js"
import style0 from "./detialBox.vue?vue&type=style&index=0&id=0ec7e6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7e6c8",
  null
  
)

export default component.exports